function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';
import PropTypes from '../../_snowpack/pkg/prop-types.js';

function SvgComponent({
  height,
  width,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M18.2587 1.2L18.3 8.9306c-5.5704 0-11.1796-.0622-16.75.0694 0-2.6028.0155-5.1984.0284-7.8 5.555 0 11.1124.006 16.6803 0z",
    fill: "#DAF0ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1494 1.35c-.0113 2.442-.0183 4.8836-.021 7.3249a.4281.4281 0 01-.423.423c-2.384-.005-4.794.073-7.178-.068a.4185.4185 0 01-.3888-.0415.4194.4194 0 01-.1852-.3445c0-2.4313-.0037-4.8626-.011-7.294a.4452.4452 0 01.439-.438c2.4407-.0046 4.882-.0046 7.324 0a.4461.4461 0 01.444.438zm-.861 6.8999l-.016-6.464c-2.154 0-4.305-.0016-6.453-.005a7098.2738 7098.2738 0 00-.011 6.526c2.155-.107 4.325-.06 6.48-.054v-.003zM18.861 1.438c-.0113 2.442-.0183 4.8837-.021 7.325a.4283.4283 0 01-.423.423c-2.384-.006-14.448.073-16.832-.063a.4223.4223 0 01-.3896-.0449.4221.4221 0 01-.1844-.3461c0-2.4307-.0037-4.862-.011-7.294A.449.449 0 011.439 1h16.978a.45.45 0 01.444.438zM18 8.338l-.016-6.463c-2.154.005-13.954 0-16.107 0 0 2.175-.011 4.345-.011 6.521C4.021 8.288 15.845 8.34 18 8.34v-.002z",
    fill: "#828A90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2716 1.789l.016 6.4639c-2.155-.006-4.325-.058-6.48.057 0-2.1753.0037-4.3506.011-6.526 2.1494.0054 4.3003.007 6.453.005z",
    fill: "#DAF0ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.201 10.438l-.016 7.325a.4277.4277 0 01-.422.423c-2.385-.006-4.795.073-7.179-.063a.4224.4224 0 01-.3896-.0449.4222.4222 0 01-.1844-.3461c0-2.4307-.0033-4.862-.01-7.294A.448.448 0 011.438 10h7.325a.4442.4442 0 01.438.438zm-.861 6.9l-.018-6.461c-2.149.005-4.3 0-6.448 0 0 2.175-.01 4.345-.01 6.521 2.158-.11 4.321-.058 6.476-.058v-.002z",
    fill: "#828A90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3223 10.877l.016 6.463c-2.155 0-4.32-.052-6.474.058 0-2.176.005-4.346.01-6.521 2.148 0 4.301.005 6.448 0z",
    fill: "#DAF0ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0681 19.3419a3886.442 3886.442 0 01-.021 7.325.427.427 0 01-.417.423c-2.389-.006-4.8.073-7.184-.063a.4228.4228 0 01-.574-.391v-7.294a.4428.4428 0 01.428-.442h7.33a.4478.4478 0 01.438.442zm-.861 6.9l-.015-6.463c-2.15.005-4.3 0-6.454 0 0 2.175 0 4.345-.01 6.521 2.154-.108 4.325-.056 6.479-.056v-.002z",
    fill: "#828A90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1915 19.781l.015 6.463c-2.154 0-4.325-.052-6.479.058 0-2.176 0-4.346.01-6.521 2.15 0 4.304.005 6.454 0z",
    fill: "#DAF0ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.264 12.8538l.2272.3018.227-.302a4.7246 4.7246 0 011.163-1.099c.7431-.4932 1.6045-.7546 2.4916-.7546.3042 0 .6083.0308.9037.0916.7831.1609 1.5221.5397 2.1363 1.0954a4.8395 4.8395 0 011.3378 2.0418c.1919.5706.2744 1.1855.2429 1.8296-.0568 1.158-.4695 2.4207-1.2917 3.8682-1.4248 2.5083-3.7175 4.7871-7.0362 6.96L19.4923 27l-.1732-.1134c-2.697-1.7658-4.7107-3.6046-6.1696-5.6184-.6745-.9311-1.5472-2.353-1.9387-3.8951-.1967-.7747-.2546-1.5098-.1785-2.1869.0868-.7716.3487-1.4864.7811-2.1274.4219-.6255.9949-1.1472 1.6574-1.5062.6629-.3592 1.4038-.5492 2.141-.5492.8865 0 1.7473.2611 2.49.7535a4.7272 4.7272 0 011.1622 1.0969z",
    fill: "#DAF0ED",
    stroke: "#828A90",
    strokeWidth: ".8"
  }));
}

SvgComponent.defaultProps = {
  width: 24,
  height: 21
};
SvgComponent.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgComponent;